export const DEBUG = 'debug';
